import React from 'react';
import PropTypes from 'prop-types';

import ProgramContentEntriesTableRow from './ProgramContentEntriesTableRow';
import ProgramContentEntriesTableHeader from './ProgramContentEntriesTableHeader';
import TableFooter from 'components/helpers/TableFooter';
import { tableNoResultsDefault, tableSpinnerDefault } from 'components/helpers/TableHelpers';

const COLUMN_COUNT = 3;

export default class ProgramContentEntriesTable extends React.Component {
  static propTypes = {
    programContentEntries: PropTypes.arrayOf(PropTypes.object).isRequired,
    allowSend: PropTypes.bool.isRequired,
    meta: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onProgramContentEntrySend: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleProgramContentEntrySend = this.handleProgramContentEntrySend.bind(this);
  }

  render() {
    const {allowSend} = this.props;

    return (
      <div className='u-margin-bottom--gutter2x'>
        <div className='table-scroll'>
          <table className='o-table o-table--bordered'>
            <ProgramContentEntriesTableHeader showActions={allowSend}/>
            <tbody>
              { this.renderBody() }
            </tbody>
          </table>
        </div>
        { this.renderFooter() }
      </div>
    );
  }

  renderBody() {
    const { programContentEntries, isLoading } = this.props;

    if (this.isLoading()) {
      return this.renderLoading();
    }

    if (this.emptyResults()) {
      return this.renderEmptyResults();
    }

    return this.renderRows();
  }

  isLoading() {
    const { programContentEntries, isLoading } = this.props;

    return programContentEntries.length == 0 && isLoading;
  }

  renderLoading() {
    return tableSpinnerDefault(COLUMN_COUNT);
  }


  emptyResults() {
    const { programContentEntries, meta: { totalPages }} = this.props;
    return programContentEntries.length == 0 && totalPages == 0;
  }

  renderEmptyResults() {
    return tableNoResultsDefault(COLUMN_COUNT);
  }

  renderRows() {
    const { programContentEntries, allowSend } = this.props;

    return programContentEntries.map(programContentEntry => (
      <ProgramContentEntriesTableRow
        key={`${programContentEntry.id}`}
        programContentEntry={programContentEntry}
        allowSend={allowSend}
        onSendClick={this.handleProgramContentEntrySend}
      />
    ));
  }

  handleProgramContentEntrySend(programContentEntry) {
    this.props.onProgramContentEntrySend(programContentEntry);
  }

  renderFooter() {
    const { meta } = this.props;

    if (!meta.totalCount || meta.totalCount == 0) return null;

    return (
      <TableFooter meta={meta} onPageChange={this.handlePageChange}/>
    );
  }

  handlePageChange(page) {
    this.props.onPageChange(page);
  }
}
